/* --- Best Selling Home Carousel ---------- */
    $('#best_selling').owlCarousel({
            loop:false,
            margin:20,
            nav:false,
            dots: false,
            mouseDrag: false,
            navText: [ '', '' ],
            responsive:{
                0:{
                    items:1,
                    stagePadding:0,
                    margin:10,
                    mouseDrag: true,
                    nav:true,
                },
                768:{
                    items:4,
                },
                1000:{
                    items:4
                }
            }
        });

/* --- Categories Home Carousel ---------- */
        $('#pro_categories').owlCarousel({
            loop:false,
            margin:10,
            nav:false,
            dots: false,
            mouseDrag: false,
            navText: [ '', '' ],
            responsive:{
                0:{
                    items:1,
                    stagePadding:40,
                    margin:5,
                    mouseDrag: true,
                 },
                768:{
                    items:2,
                    stagePadding:40,
                    margin:5,
                    mouseDrag: true,
                 },
                1000:{
                    items:3
                }
            }
        });

/* --- Footer and Product Filter Accordion ---------- */


	$('.collapse').on('shown.bs.collapse', function(){
    $(this).parent().find(".glyphicon-plus").removeClass("glyphicon-plus").addClass("glyphicon-minus");
    }).on('hidden.bs.collapse', function(){
    $(this).parent().find(".glyphicon-minus").removeClass("glyphicon-minus").addClass("glyphicon-plus");
    });

    /*
      $('.panel-collapse').collapse({toggle: false});
      $('body').on('click', '[data-toggle=collapse-next]', function (e) {
      e.preventDefault();

      // Try to close all of the collapse areas first
      var parent_id = $(this).data('parent');
      $(parent_id+' .panel-collapse').collapse('hide');

      // ...then open just the one we want
      var $target = $(this).parents('.panel').find('.panel-collapse');
      $target.collapse('toggle');
      });
    */

/* --- Header Search for Mobile and Tablet ---------- */
    $(document).ready(function(){
        $("#flip").click(function(){
            $("#panel").slideToggle("slow");
        });
    });
	$(document).ready(function(){
        $("#help").click(function(){
            $("#helpdrop").slideToggle("slow");
        });
    });

/* --- Main Menu for Mobile and Tablet ---------- */
$(document).ready(function () {
  var trigger = $('.hamburger'),
      overlay = $('.overlay'),
     isClosed = false;

    trigger.click(function () {
      hamburger_cross();
    });

    function hamburger_cross() {

      if (isClosed == true) {
        overlay.hide();
        trigger.removeClass('is-open');
        trigger.addClass('is-closed');
        isClosed = false;
      } else {
        overlay.show();
        trigger.removeClass('is-closed');
        trigger.addClass('is-open');
        isClosed = true;
      }
  }

  $('[data-toggle="offcanvas"]').click(function () {
    $('#wrapper').toggleClass('toggled');
  });
});

/* --------------- */
